import useDashboardHome
from "../hooks/useDashboardHome";
import useRemoteAssets from "../utils/useRemoteAssets";

export default function DashboardHome() {
   const ASSETS = useRemoteAssets();
 const {
  accounts,
  handleSelect,
  Button,
  loading,
  navigate,
} = useDashboardHome();
  

if (!ASSETS || loading) {
  return <div>Loading...</div>;
}
  return (
    <>

      {/* ================= MOBILE ================= */}

      <div className="flex flex-col items-center w-full px-4 md:hidden">

        <div className="w-full max-w-[328px] flex flex-col gap-4">

          <h2 className="text-[18px] font-medium">

            Select an account

          </h2>

          <div className="grid grid-cols-2 gap-3">

            {accounts?.map((acc, i) => (

              <div
                key={`${acc.name}-${i}`}
                onClick={() => handleSelect(acc)}
                className="relative w-full h-[145px] bg-[#D5384617] rounded-2xl p-3 flex flex-col justify-end cursor-pointer"
              >

                <div className="absolute top-2 right-2 w-[41px] h-[41px]">

                  <img
                    src={ASSETS.icon11}
                    className="w-[44px] h-[44px]"
                  />

                </div>

                <div>

                  <p className="text-[12px] relative -top-6">

                    {acc.name}

                  </p>

                  <p className="text-[16px] font-medium relative -top-6">

                    {acc.role}

                  </p>

                  <p className="text-[11px]">

                    {acc.activeStatus}

                  </p>

                </div>
              </div>

            ))}

          </div>
        </div>
      </div>

      {/* ================= DESKTOP ================= */}

      <div className="flex-col hidden w-full h-full md:flex">

        {/* HEADER */}

        <div className="flex justify-end">

          <div className="flex items-center gap-3 w-[clamp(180px,20vw,245px)]">

            <img
              src={ASSETS.logo}
              className="w-[44px] h-[44px]"
            />

            <h1 className="text-[clamp(24px,3vw,40px)] font-pattaya">

              Ambit Tech

            </h1>

          </div>
        </div>

        {/* TOP BAR */}

        <div className="mt-6">

          <div className="w-full h-[2px] bg-[#CF0018]" />

          <div className="flex items-center justify-between mt-4">

            <p>

              Member/

              <span className="font-bold">

                My account

              </span>

            </p>

            {Button ? (

              <Button
                token="my-secret-token"
                onClick={() =>
                  navigate("/dummy")
                }
                className="bg-[#CF0018] text-white px-6 py-2 rounded-lg"
              >

                Create

              </Button>

            ) : (

              <div>Loading...</div>

            )}

          </div>
        </div>

        {/* CONTENT */}

        <div className="mt-10 w-full max-w-[861px] mx-auto">

          <h2 className="text-center text-[20px]">

            Select an account
            to perform operations
            and Transactions

          </h2>

          <div className="flex flex-col gap-4 mt-6">

            {accounts?.map((acc, i) => (

              <div
                key={`${acc.name}-${i}`}
                onClick={() => handleSelect(acc)}
                className="w-full bg-[#D5384617] rounded-xl p-6 flex justify-between items-center cursor-pointer"
              >

                <div className="flex flex-col gap-3 w-[196px] h-[111px]">

                  <h3 className="text-black/60">

                    {acc.name}

                  </h3>

                  <p>

                    {acc.activeStatus}

                  </p>

                  <p className="font-semibold">

                    Role : {acc.role}

                  </p>

                </div>

                <div className="flex items-center justify-end w-full">

                  <div className="relative right-5">

                    <div className="w-5 h-5">

                      <div className="absolute top-2 right-2 w-[41px] h-[41px]">

                        <img
                          src={ASSETS.icon11}
                          className="w-[44px] h-[44px]"
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

            ))}

          </div>
        </div>
      </div>
    </>
  );
}